export enum TURN_ACTION {
  BET = 'BET',
  PLAY_CARD = 'PLAY_CARD'
}
